import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
function isSchemeType(value) {
    return ["dark", "light", "system"].includes(value);
}
var DisplayThemeContext = createContext({
    setScheme: function () { },
    scheme: "system",
    theme: "light",
});
var ATTRIBUTE_THEME = "data-fr-theme";
var ATTRIBUTE_SCHEME = "data-fr-scheme";
var supportLocalStorage = function () {
    try {
        return "localStorage" in window && window.localStorage !== null;
    }
    catch (e) {
        console.warn(e);
        return false;
    }
};
export var useThemeContext = function () { return useContext(DisplayThemeContext); };
export var ThemeProvider = function (_a) {
    var children = _a.children, _b = _a.defaultScheme, defaultScheme = _b === void 0 ? "system" : _b;
    var defaultSchemeState = useMemo(function () {
        if (supportLocalStorage()) {
            var schemeLocalStorage = localStorage.getItem("scheme");
            if (schemeLocalStorage && isSchemeType(schemeLocalStorage)) {
                return schemeLocalStorage;
            }
        }
        if (defaultScheme && isSchemeType(defaultScheme)) {
            return defaultScheme;
        }
        return "light";
    }, []);
    var _c = useState(defaultSchemeState), scheme = _c[0], setScheme = _c[1];
    var setSchemeString = function (scheme) {
        var newScheme = isSchemeType(scheme) ? scheme : "light";
        console.log(newScheme);
        setScheme(newScheme);
        document.documentElement.setAttribute(ATTRIBUTE_SCHEME, newScheme);
        if (supportLocalStorage()) {
            localStorage.setItem("scheme", newScheme);
        }
    };
    var theme = useMemo(function () {
        if (scheme === "system") {
            var mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
            if (mediaQuery.matches) {
                return "dark";
            }
            else {
                return "light";
            }
        }
        else if (scheme === "dark") {
            return "dark";
        }
        else {
            return "light";
        }
    }, [scheme]);
    useEffect(function () {
        document.documentElement.setAttribute(ATTRIBUTE_THEME, theme);
    }, [theme]);
    var contextThemeValue = useMemo(function () { return ({
        setScheme: setSchemeString,
        scheme: scheme,
        theme: theme,
    }); }, [scheme, setScheme, theme]);
    return (React.createElement(DisplayThemeContext.Provider, { value: contextThemeValue }, children));
};
